import {Injectable} from '@angular/core';
import {NavigationCancel, NavigationEnd, NavigationError, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {debounceTime, filter, take} from 'rxjs/operators';
import {injectScript} from 'app/core/helpers/dom';
import {environment} from '../../../environments/environment';
import {EnvName, getEnvName} from '../../../environments/env-name';

const HotJarScript = `
    (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:1752884,hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
`;

@Injectable({
    providedIn: 'root',
})
// Should be included only on certain pages
// just on leaving them - the page should be refreshed
export class HotjarService {
    sub = Subscription.EMPTY;
    private isScriptInjected = false;

    constructor(private router: Router) {}

    injectHotJar() {
        if (environment.enableHotJar && getEnvName() === EnvName.Prod) {
            injectScript(HotJarScript, document.head);
        } else {
            console.debug('[HotJar] Kinda Injecting HotJar script');
        }
    }

    canActivate() {
        // if new url should also include hotjar we cancel subscription which should reload page
        this.sub.unsubscribe();
        if (!this.isScriptInjected) {
            this.isScriptInjected = true;
            this.injectHotJar();
        }
        return true;
    }

    canDeactivate() {
        // wait navigation end
        this.sub = this.router.events
            .pipe(
                filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError),
                // await navigation end + some rendering
                debounceTime(10),
                take(1),
                debounceTime(10)
            )
            .subscribe(() => this.reloadPage());

        return true;
    }

    reloadPage() {
        document.location = document.location;
    }
}
